import * as types from '../actions/actionTypes';
import cloneDeep from "lodash/cloneDeep";
import find from "lodash/find";

const initialState = {
  filterGroups: [],
  selectedFilters: [],
  expandedFilters: [],
  showFilters: false,
  filterVisible: '',
  filterId: "",
  availableFilterValues: {}, // { filterGroupId: arrayOf(filterValues) }
  filtersCount: 0, // to update component when filters received
  alreadyRequestedNames: [],
};

function loadFilterGroups(filterGroups) {
  filterGroups.forEach(fg => {
    for(let i = fg.values.length - 1; i>= 0; i--) {
      let value = fg.values[i];
      if(value.parent_id) {
        let parent = find(fg.values, v => v.id == value.parent_id);
        parent.items = parent.items || [];
        parent.items.push(fg.values.splice(i, 1)[0]);
      }
    }
  });
  return filterGroups;
}

export default function(state = initialState, action) {
  let newState = {...state};
  switch(action.type) {
    case types.LOAD_FILTERS:
      newState.filterGroups = loadFilterGroups(cloneDeep(action.payload));
    break;
    case types.SET_SELECTED_FILTERS:
      newState.selectedFilters = [...action.payload];
    break;
    case types.SET_EXPANDED_FILTERS:
      newState.expandedFilters = [...action.payload];
      break;
    case types.SHOW_FILTERS:
      newState.showFilters = action.payload.show;
      newState.filterId = action.payload.filterId;
      newState.filterVisible = "Others";
      break;
    case types.SHOW_FILTERS_IF_NOT_VISIBLE:
      if(!newState.showFilters) {
        newState.showFilters = true;
        newState.filterId = action.payload;
        newState.filterVisible = "Others";
      }
      break;
    case types.SET_FILTER_VISIBLE:
      newState.filterVisible = action.payload;
      break;
    case types.SET_AVAILABLE_FILTER_VALUES:
      return Object.assign({}, state, {
        availableFilterValues: Object.assign({}, state.availableFilterValues, action.payload.availableFilterValues)
      });
    case types.SET_SEARCH_NAMES_REQUESTED:
      return Object.assign({}, state, {
        alreadyRequestedNames: [...state.alreadyRequestedNames, action.payload]
      });
    case types.UPDATE_FILTERS_COUNT:
      return Object.assign({}, state, {
        filtersCount: state.filtersCount + 1
      })
    case types.SET_COUNTERTOP_FILTERS_RECEIVED:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_OPENED:
      if (!action.payload.lookOpened) {
        return Object.assign({}, state, { selectedFilters: [] });
      }
      break;
    case types.SET_LOOK_ACTIVE_CATEGORY:
      if (!action.payload.lookActiveCategory) {
        return Object.assign({}, state, { selectedFilters: [] });
      }
      break;
    case types.SET_SHOP_PAGE_OPENED:
      if (!action.payload.shopPageOpened) {
        return Object.assign({}, state, { selectedFilters: [] });
      }
      break;
    case types.SET_WIZARD_ACTIVE_STEP:
      if (state.selectedFilters.length) {
        return Object.assign({}, state, { selectedFilters: [] }); // always remove it on step change
      }
      break;
  }
  return newState;
}
